import { render, staticRenderFns } from "./Suspensions.vue?vue&type=template&id=b5fc0abe&"
import script from "./Suspensions.vue?vue&type=script&lang=js&"
export * from "./Suspensions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports